<template>
  <div class="main">
    <div class="nav-wrap">
      <nav-bar :routers="routers"></nav-bar>
    </div>

    <router-view :grade-id="gradeId" :subject-list="mainSubjectList" :school-id="schoolId"></router-view>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import { xGaokao } from '@/utils/gaokao'
export default {
  props: ['gradeId', 'subjectList', 'schoolId'],
  data () {
    return {
      routers: [],
    }
  },
  computed: {
    mainSubjectList () {
      return this.subjectList.filter(item => {
        return ['33', '60'].find(row => row !== item.subjectCode)
      })
    }
  },
  created () {
    const query = this.$route.query
    query.id = this.$route.params.id
    this.routers = xGaokao.getSubjectRouters(query, 'like')
  },
  components: {
    NavBar
  }
};
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-flow: row;

  .nav-wrap {
    position: relative;
    margin: 14px 20px 0 0;
    width: 155px;
  }
}
</style>
